export default __webpack_public_path__ + "static/media/bflyear.63b7d6a8.jpg";